import * as React from 'react';
import Barcodes from '../barcode/Barcodes';
import AuxiliaryFields from '../fields/AuxiliaryFields';
import PrimaryFields from '../fields/PrimaryFields';
import SecondaryFields from '../fields/SecondaryFields';
import LogoLogoTextHeaderFields from './LogoTextHeaderFields';
import ImagePreview from '../images/ImagePreview';
import { ImageTypes } from '../../../../types';
import { useTheme } from '../../Theme';
import { createUseStyles } from 'react-jss';
export const useStyles = createUseStyles({
  primaryFieldThumbnailContainer: {
    display: 'table',
    //  paddingLeft: ({ theme }) => theme.scale * 12,
    //  paddingRight: ({ theme }) => theme.scale * 12,
    width: '100%'
  },
  primaryFieldContainer: {
    display: 'table-cell',
    width: ({
      theme
    }) => theme.scale * 210,
    verticalAlign: 'top'
  },
  thumbnailContainer: {
    display: 'table-cell'
  }
});
export default function Generic() {
  const theme = useTheme();
  const classes = useStyles({
    theme
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LogoLogoTextHeaderFields, null), /*#__PURE__*/React.createElement("div", {
    className: classes.primaryFieldThumbnailContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.primaryFieldContainer
  }, /*#__PURE__*/React.createElement(PrimaryFields, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.thumbnailContainer
  }, /*#__PURE__*/React.createElement(ImagePreview, {
    imageType: ImageTypes.thumbnail
  }))), /*#__PURE__*/React.createElement(SecondaryFields, null), /*#__PURE__*/React.createElement(AuxiliaryFields, null), /*#__PURE__*/React.createElement(Barcodes, null));
}
//# sourceMappingURL=Generic.js.map